import React, { Component } from 'react';
import PropTypes from 'prop-types';

import config from 'config';
import Icon from 'common/icon';
import NumberInput from 'common/number-input';

export default class CustomSelect extends Component {
    static propTypes = {
        value: PropTypes.number.isRequired,
        onChange: PropTypes.func.isRequired,
        onPresets: PropTypes.func.isRequired,
        showFlash: PropTypes.func.isRequired,
    };

    state = {
        // eslint-disable-next-line react/destructuring-assignment
        value: this.props.value / 100,
    };

    handleValueChange = value => this.setState({ value: +value });

    handleInputBlur = () => {
        const { onChange, showFlash } = this.props;
        const { value } = this.state;
        const minimum = config('/minimum_tip_charge');
        let amount = value * 100;

        // Handle minimum tip value
        if (amount < minimum && amount !== 0) {
            amount = minimum;
            this.setState({ value: amount / 100 });

            showFlash({
                type: 'danger',
                title: 'Minimum Tip!',
                message: 'There is a minimum tip of $0.50 due to credit card processing fees.',
                duration: 5000,
            });
        }

        onChange(amount);
    };

    render() {
        const { onPresets } = this.props;
        const { value } = this.state;

        return (
            <form onSubmit={e => e.preventDefault()}>
                <div className="flex items-center">
                    <span className="text-gray-30 font-medium text-21 inline-block pr-4">$</span>
                    <NumberInput
                        id="custom-amount"
                        value={value}
                        className="input-default w-64 md:w-48"
                        onValueChange={this.handleValueChange}
                        onBlur={this.handleInputBlur}
                        data-testid="tip-amount-custom"
                        autoFocus
                    />
                    <div className="pl-4">
                        <button type="button" onClick={onPresets} className="link-gray">
                            <Icon icon="undo" className="text-21" />
                        </button>
                    </div>
                </div>
                <input type="submit" className="hidden" />
            </form>
        );
    }
}
